module.exports = __webpack_public_path__ + "static/media/pt3.c6f5450f.jpg";